<template>
  <v-content style="height: 100%">
    <v-layout justify-end  >
      <v-btn
          depressed
          large
          color="#FF4F23"
          class="px-7 text-start white--text titleHeader mt-5 mx-5"
          @click.stop="drawer = !drawer">
        <v-icon class="mr-2">add</v-icon>
        เพิ่ม
      </v-btn>
    </v-layout>
    <v-layout justify-center mt-5>
      <v-flex pa-4>
        <v-layout  justify-center>
          <v-flex>
            <v-data-table
                :items="this.devdata"
                :server-items-length="statisticTotal"
                style="border: solid 1px #FF4F23">
              <template v-slot:header="{ item, index }">
                <thead class="white--text" style="background-color: #4F4F4F">
                <tr>
                                    <td width="5%">ลำดับ</td>
                                    <td width="10%">ชื่อชุดข้อมูล</td>
                                    <td width="10%">วันที่แก้ไข</td>
                                    <td width="10%">วันที่ประกาศชุดข้อมูล</td>
                                    <td width="5%">ดูไฟล์นำเข้า</td>
                                    <td width="10%">แก้ไข</td>
                </tr>
                </thead>
              </template>
              <template v-slot:item="{ item, index }">
                                <tr >
                                  <td>{{ index+1}}.</td>
                                  <td class="text-start">{{ item.name_th }}</td>
                                  <td>{{ item.updated_at | moment("DD/MM/YYYY") }}</td>
                                  <td>{{ item.data_import_date | moment("DD/MM/YYYY") }}</td>
                                  <td>
                                    <v-icon color="#FF4F23" @click="openFile(item.file_path)">search</v-icon>
                                  </td>
                                  <td><v-icon @click="onEditStatistic(item)" color="#FF4F23">{{ mdiPencil }}</v-icon></td>
                                </tr>
                              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>



    <v-navigation-drawer
        v-model="drawer"
        absolute
        style="position: fixed"
        :width="$vuetify.breakpoint.mdAndUp ? '65%':'90%'"
        temporary
        right
    >
      <v-layout pa-3>
        <v-flex shrink mr-12>
          <v-btn fab
                 small
                 depressed
                 @click.stop="drawer = !drawer"
                 @click="$event,clearForm()"
                 style="background-color: transparent; position: fixed">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex mr-7>
          <v-layout column>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                วันที่ประกาศชุดข้อมูล :
              </v-flex>
              <v-flex xs7>
                <v-date-picker
                    style="padding: 11px"
                    type="date"
                    locale="TH"
                    v-model="data.data_import_date"
                    solo
                    flat
                ></v-date-picker>
              </v-flex>
            </v-layout>
            <!-- Language TH-->
            <v-layout justify-start mt-4>
              <v-flex shrink class="txt-head cea-color">
                Language TH
              </v-flex>
            </v-layout>
            <div class="my-3 cea-underline"></div>

            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                ชื่อชุดข้อมูล (TH) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.name_th"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                รายละเอียดข้อมูล (TH) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.description_th"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                แหล่ง Reference (TH) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.reference_th"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                วิธีการใช้ชุดข้อมูล (TH) :
              </v-flex>
              <v-flex xs7>
                <v-textarea
                    v-model="data.howto_th"
                    solo
                    flat
                ></v-textarea>
              </v-flex>
            </v-layout>

            <!-- Language EN-->
            <v-layout justify-start mt-4>
              <v-flex shrink class="txt-head cea-color">
                Language EN
              </v-flex>
            </v-layout>
            <div class="my-3 cea-underline"></div>

            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                ชื่อชุดข้อมูล (EN) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.name_en"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                รายละเอียดข้อมูล (EN) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.description_en"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                แหล่ง Reference (EN) :
              </v-flex>
              <v-flex xs7>
                <v-text-field
                    v-model="data.reference_en"
                    solo
                    flat
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end pt-3>
              <v-flex shrink pt-3 mr-4>
                วิธีการใช้ชุดข้อมูล (EN) :
              </v-flex>
              <v-flex xs7>
                <v-textarea
                    v-model="data.howto_en"
                    solo
                    flat
                ></v-textarea>
              </v-flex>
            </v-layout>
            <div class="my-3 cea-underline"></div>
            <v-layout justify-end>
              <v-flex shrink pt-3 mr-4>
                ไฟล์แนบ :
              </v-flex>
              <v-flex xs7>
                        <span v-if="file_name">
                          <v-layout justify-start class="mt-3">
                              {{this.file_name}}
                            <v-icon @click="clearFile"
                                    class="cancleBtn ml-3" style="color: #FF4F23">close</v-icon>
                          </v-layout>
                        </span>
                <v-layout justify-start class="mt-3">
                  <p style="color: red" v-if=" !this.data.name_en || !this.data.name_th">โปรดกรอกชื่อชุดข้อมูล (TH)/(EN)</p>
                </v-layout>
                <span v-if="!file_name && this.data.name_en && this.data.name_th ">
                        <v-file-input
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            prepend-icon
                            append-icon="attach_file"
                            color="#FF4F23"
                            solo
                            flat
                            clear
                            @change="importFile($event)"
                        ></v-file-input>
                        </span>

              </v-flex>
            </v-layout>
            <div class="my-3 cea-underline"></div>

            <v-layout justify-end my-5>
              <v-btn large color="#8A8A8A" class="mr-5 white--text"  @click="onDelete(data.id,data.name_th)">ลบ</v-btn>
              <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>


  </v-content>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Service from "../services";
import { domain } from "../services/Constants";
import axios from "axios";
import Swal from "sweetalert2";
import {mdiPencil} from '@mdi/js';

export default {
  name: "developerManage",
  props: ["section"],
  components: {
  },
  data: () => ({
    msg:'',
    mdiPencil:mdiPencil,
    drawer: null,
    dataParam: {},
    pageVisible: 8,
    http: domain,
    keywordTopic: "",
    keywordImport: "",
    tagLoaded: false,
    sectionLoaded: true,
    search: '',
    file_name:'',
    file_path:'',
    data:{
      id:'',
      name_th: '',
      name_en: '',
      description_th: '',
      description_en: '',
      reference_th: '',
      reference_en: '',
      howto_th: '',
      howto_en: '',
      data_import_date: '',
      file_path: '',
      updated_at: '',
    },
    headers: [

      { text: 'ลำดับ', value: 'No' ,align: 'center', },
      { text: 'ชื่อ', value: 'name_th',align: 'center' },
      { text: 'วันที่แก้ไข', value: 'update_at',align: 'center' },
      { text: 'ดูข้อมูล', value: 'view',sortable: false,align: 'center' },
      { text: 'แก้ไข', value: 'edit',sortable: false,align: 'center' },
    ],
    // dataTable:[],
  }),
  created() {
    this.$store.dispatch("DevData/onGetAllDevData");
  },
  watch: {
    // re-render pagination
    section: function () {
      this.importedLoaded = false;
      this.topicLoaded = false;
      this.unitLoaded = false;
      this.tagLoaded = false;
      setTimeout(() => {
        this.importedLoaded = true;
        this.topicLoaded = true;
        this.unitLoaded = true;
        this.tagLoaded = true;
      }, 1);
    },

  },
  computed: {
    ...mapState({
      devdata:(state) => state.DevData.dataDev,
      footer: (state) => state.site.footer,
      statistics: state => state.statistic.statistics,
      statisticTotal: state => state.statistic.statisticTotal
    }),
  },
  methods: {
    async onAddStatistic() {
      this.clearForm();
      this.drawer = !this.drawer
    },
    async onEditStatistic(item) {
      this.clearForm();
      this.clearFile();
      // console.log("itemxx",item)
      this.drawer = !this.drawer
      this.data=item
      this.file_name = item.file_path

    },
    openFile(file_path) {
      // console.log("file_path === " ,file_path)
      if (file_path || file_path!=null && file_path !=""){
      window.open(this.http + "/" + file_path);
      }else {
        Swal.fire({
          icon:"error",
          title:"ผิดพลาด!",
          text:"ไม่มีข้อมูล"
        })
      }
    },
    clearFile(){
      this.file_name = null
    },
    async importFile(file){
      let formData = new FormData();
      let name =  this.data.name_en
      formData.append('file_path', file);
      formData.append('file_name', name);
      this.data.file_path = this.data.file_path;
      axios({
        url: domain + '/api/developerdata/importExcel',
        method: "POST",
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res){
          // console.log("res",res)
          name = res.data.replace('uploads/files/','')
          this.file_name =name+'';
          this.data.file_path = res.data
          name =null;
        }else {
          // console.log("res error",res)
        }

      })
    },
    saveForm(){
      let data={
        id: this.data.id,
        name_th: this.data.name_th,
        description_th: this.data.description_th,
        reference_th: this.data.reference_th,
        howto_th: this.data.howto_th,
        name_en: this.data.name_en,
        description_en: this.data.description_en,
        reference_en: this.data.reference_en,
        howto_en: this.data.howto_en,
        data_import_date: this.data.data_import_date,
        file_path: this.data.file_path,
      }

      // eslint-disable-next-line no-console
      // console.log("data",typeof (data) )
      // console.log("data", data )
      let formData = new FormData();
      formData.append('name_th', data.name_th);
      formData.append('description_th', data.description_th);
      formData.append('reference_th', data.reference_th);
      formData.append('howto_th', data.howto_th);
      formData.append('name_en', data.name_en);
      formData.append('description_en', data.description_en);
      formData.append('reference_en', data.reference_en);
      formData.append('howto_en', data.howto_en);
      formData.append('data_import_date', data.data_import_date);
      formData.append('file_path', data.file_path);

      if (!data.id){
        axios({
          url: domain + '/api/developerdata/add',
          method: "POST",
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((res) => {
          // console.log(res);
          this.$store.dispatch("DevData/onGetAllDevData");
          Swal.fire({
            icon:"success",
            title:"เรียบร้อย!"
          })
          this.clearForm();
          this.drawer =!this.drawer;
        }) .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          Swal.fire({
            icon:"error",
            title:err
          })
        });
      }else {
        this.$store.dispatch("DevData/onUpdateDevData",data).then((result) => {
          // console.log(result)
          this.$store.dispatch("DevData/onGetAllDevData",data)
          Swal.fire({
            icon:"success",
            title:"เรียบร้อย!"
          })
          this.drawer = !this.drawer;
          this.clearForm();
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          Swal.fire({
            icon:"error",
            title:err
          })
          this.sectionLoaded = false;
        });
      }
    },
    async onDelete(id,name){
      Swal.fire({
        title: 'ต้องการลบชุดข้อมูล ' +name+ ' ?',
        showCancelButton: true,
        confirmButtonText: `ตกลง`,
        cancelButtonText:`ยกเลิก`,
        cancelButtonColor:`red`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$store.dispatch("DevData/onDeleteDevData",id)
              .then((result) => {
                // console.log(result)
                this.$store.dispatch("DevData/onGetAllDevData",id)
                Swal.fire({
                  icon:"success",
                  title:"เรียบร้อย!"
                })
                this.clearForm();
                this.drawer = !this.drawer;
              }).catch((err) => {
            // eslint-disable-next-line no-console
            Swal.fire({
              icon:"error",
              title:err
            })
            this.sectionLoaded = false;
          });
        } else if (result.isDenied) {
          this.clearForm()
          this.drawer =!this.drawer
        }
      })

    },
    clearForm(){
      this.file_name = '';
      this.data={
        id:'',
        name_th: '',
        name_en: '',
        description_th: '',
        description_en: '',
        reference_th: '',
        reference_en: '',
        howto_th: '',
        howto_en: '',
        data_import_date: '',
        file_path: '',
        updated_at: '',
      };
    }

  },
};
</script>

<style scoped>
.theme--light.v-data-table thead tr td:not(:last-child),
.theme--light.v-data-table tbody tr td:not(:last-child) {
  border-right: solid 1px #d7d7d7 !important;
}
.closeBtn:hover{
  color:#FF4F23;
}
.banner-box {
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
}
.banner-preview {
  max-height: 100px;
  max-width: 300px;
}
</style>
